<template>
  <div class="loader-container">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  
};
</script>

<style lang="scss">
  .loader-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left:0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;
  }
  
  .loader {
    border: 5px solid $blue-900;
    border-top: 5px solid #FFFFFF;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    animation: spin 0.5s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
